module.exports = __webpack_public_path__ + "img/sprite.f9e2a301.svg";